import React from "react";
import { Layout } from "antd";
import DarkNavbar from "../landingPage/header/DarkNavbar";
import Footer from "../landingPage/footer";
import CookieConsentBanner from "../cookieConsentBanner";
import HeroSection from "./HeroSection/HeroSection";
import AssetsSection from "./AssetsSection/AssetsSection";
import ValuePropsSection from "./ValuePropsSection/ValuePropsSection";
import WorkflowSection from "./WorkflowSection/WorkflowSection";
import SpatialSection from "./SpatialSection/SpatialSection";
import FaqSection from "./FaqSection/FaqSection";
import CtaSection from "./CtaSection/CtaSection";
import "./LandingV2.scss";

const LandingV2 = () => {
    return (
        <div className="landing-v2">
            <CookieConsentBanner />
            <DarkNavbar hideCta />
            <Layout className="top-margins" role="main">
                <HeroSection />
                <AssetsSection />
                <ValuePropsSection />
                <WorkflowSection />
                <SpatialSection />
                <FaqSection />
                <CtaSection />
            </Layout>
            <Footer />
        </div>
    );
};

export default LandingV2;
